import { Realty, services } from '@ambita/ambita-components-core';

const util = services.util;

function transformDevelopers(developersData: Realty.ApiResponse) {
  if (developersData.items && developersData.items.length > 0) {
    const developers: Realty.ApiPerson[] = developersData.items;
    const retObject: any = {
      developers: []
    };

    developers.forEach((developer: Realty.ApiPerson) => {
      const tmpObj: any = util.pick(developer, [
        'name',
        'organizationNumber'
      ]);

      tmpObj.role = 'developer';
      retObject.developers.push(tmpObj);
    });
    return retObject;
  }
}

export default transformDevelopers;
